import { render, staticRenderFns } from "./cn_footer.vue?vue&type=template&id=1aa65718&scoped=true&"
import script from "./cn_footer.vue?vue&type=script&lang=js&"
export * from "./cn_footer.vue?vue&type=script&lang=js&"
import style0 from "./cn_footer.vue?vue&type=style&index=0&id=1aa65718&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa65718",
  null
  
)

export default component.exports